import React from 'react';
import { View } from 'react-native';
import { useNavigation, useRoute, type RouteProp } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import Button from '@md-design-system/Button/Button';
import { ActivityName } from '../types';
import { getVitalParameterName } from '../utils';

type AlertEscalationParams = { vitalParameterName: string };
type AlertEscalationRouteProp = RouteProp<Record<string, AlertEscalationParams>, string>;
type AlertEscalationNavigationProp = NativeStackNavigationProp<any>;

export const AlertEscalationScreen = () => {
    const navigation = useNavigation<AlertEscalationNavigationProp>();
    const route = useRoute<AlertEscalationRouteProp>();
    const { vitalParameterName } = route.params;
    const { t } = dynamicTranslations();

    const handleBackToHome = () => {
        navigation.navigate('Homepage');
    };

    const vitalParamKey = getVitalParameterName(vitalParameterName as ActivityName);

    return (
        <MainLayout navigation={handleBackToHome}>
            <View className="flex-1 justify-between py-6">
                <View className="gap-6">
                    <View className="gap-4">
                        <Head type="h2">
                            {t(vitalParamKey)} {t('screens.remeasurement.result.still_abnormal.title')}
                        </Head>
                        <Text className="text-gray-600">
                            {t('screens.remeasurement.result.still_abnormal.description')}
                        </Text>
                        <Text className="text-gray-600">
                            {t('screens.remeasurement.result.still_abnormal.additional_info')}
                        </Text>
                    </View>
                </View>

                <View className="pt-6">
                    <Button
                        variant="outline"
                        size="large"
                        onPress={handleBackToHome}
                    >
                        {t('screens.remeasurement.back-to-start')}
                    </Button>
                </View>
            </View>
        </MainLayout>
    );
};

export default AlertEscalationScreen;
